module.exports = __webpack_public_path__ + "static/logo-ce545dfbb77eb8f11af5049790b16c6f.svg";